import Styles from "../styles/footer.module.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={Styles.footer}>
      <p>© {currentYear} Vet Viajante. Todos os direitos reservados.</p>
      <p>
        UI e UX Design e desenvolvimento por Pamela Moreira. Conteúdo fornecido
        por Thaís Santos.
      </p>
    </div>
  );
};
export default Footer;
